export default "__VITE_ASSET__Zm_ykQRH__"